/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complement`)
};

const es_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento`)
};

const de_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplement`)
};

const nl_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complement`)
};

const fr_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complément`)
};

const it_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento`)
};

const pt_br2_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento`)
};

const pt_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento`)
};

const ja_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相補配列`)
};

const zh_revcomp_op_comp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`互补`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_op_comp = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_op_comp(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_op_comp", locale)
	if (locale === "en") return en_revcomp_op_comp(inputs)
	if (locale === "es") return es_revcomp_op_comp(inputs)
	if (locale === "de") return de_revcomp_op_comp(inputs)
	if (locale === "nl") return nl_revcomp_op_comp(inputs)
	if (locale === "fr") return fr_revcomp_op_comp(inputs)
	if (locale === "it") return it_revcomp_op_comp(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_op_comp(inputs)
	if (locale === "pt") return pt_revcomp_op_comp(inputs)
	if (locale === "ja") return ja_revcomp_op_comp(inputs)
	return zh_revcomp_op_comp(inputs)
};